import { render } from "./StudentCustomColumnEdit.vue?vue&type=template&id=5e19460b&scoped=true&ts=true"
import script from "./StudentCustomColumnEdit.vue?vue&type=script&lang=ts"
export * from "./StudentCustomColumnEdit.vue?vue&type=script&lang=ts"

import "./StudentCustomColumnEdit.vue?vue&type=style&index=0&id=5e19460b&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e19460b"]])

export default __exports__